import * as yup from "yup";
import { useForm } from "react-hook-form";
import useAuthentication from "../../../hooks/useAuthentication";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { useNavigate } from "react-router";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../../shared/components/form/Form";
import { yupResolver } from "@hookform/resolvers/yup";
import { HOME } from "../../../shared/lib/routesResolver";
import { Input } from "../../../shared/components/input/Input";
import { Button } from "../../../shared/components/button/Button";
import useToastWrapper from "../../../hooks/useToastWrapper";
import { SymbolIcon } from "@radix-ui/react-icons";
import { useState } from "react";

const LoginForm = () => {
  const auth = useAuthentication();
  const storage = useLocalStorage();
  const navigate = useNavigate();
  const toast = useToastWrapper();

  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object({
    username: yup.string().required("El nombre de usuario es obligatorio"),
    password: yup.string().required("La contraseña es obligatoria"),
  });

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: { username: "", password: "" },
  });

  const onSubmitHandler = async (values) => {
    setIsLoading(true);
    auth
      .login(values.username, values.password)
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          storage.storeToken(data.token);
          storage.storePermissions(data.roles[0].permissions);
          storage.storeUser(data.user);
          setTimeout(() => {
            navigate(HOME);
          }, 500);
        } else {
          const jsonResponse = await response.json();
          const message = jsonResponse.message;
          throw new Error(message);
        }
      })
      .catch((e) => {
        toast.error(`Error iniciando sesión: ${e}`);
        console.log(`Error fetched: ${e}`);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmitHandler)}
        className="w-full px-5"
      >
        <div className="flex flex-col justify-center gap-y-2">
          <FormField
            control={form.control}
            name="username"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    placeholder="Usuario"
                    {...field}
                    disabled={isLoading}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    type="password"
                    placeholder="Contraseña"
                    {...field}
                    disabled={isLoading}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex flex-row mt-8 justify-center">
          <Button className="w-full" type="submit" disabled={isLoading}>
            {isLoading && <SymbolIcon className="mr-2 h-4 w-4 animate-spin" />}
            Iniciar sesión
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default LoginForm;
